<template>
    <div>
        <AdminProductList :data="products" product-name="lashus" product-code="lh" @on-deleted-item="fetchLh"></AdminProductList>
    </div>
</template>

<script>
    import AdminProductList from "@/components/admin/AdminProductList";
    import ApiServiceAdmin from "@/services/ApiServiceAdmin";
    export default {
        components: {
            AdminProductList
        }, 
        data() {
            return {
                products: [],
                totalForSlug: {},
                activetab: 1
            }
        },
        methods: {
            fetchLh() {
                ApiServiceAdmin.getLh().then((response) => {
                    this.products = response.data;
                });
            },
        },
        mounted() {
            this.fetchLh();
        },
    }

</script>